// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectDifficulty_container__1bBV8","button":"SelectDifficulty_button__2SzTj"};